<template>
  <v-list-item
    v-if="product"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div
      :style="`width: ${imageWidth}px; max-width: ${imageWidth}px; height: ${imageHeight+16}px;`"
      class="pa-1 mr-2 mt-2 mb-auto"
    >
      <v-img
        v-if="product.Image"
        :height="imageHeight"
        :src="product.Image"
        class="rounded"
      />
      <div
        v-else
        :style="`width:100%; height: ${imageHeight}px;`"
        class="brand-primary lighten-5 rounded text-center justify-center align-center d-inline-flex"
      >
        <img
          v-if="!storeLogo && productStoreLogo"
          :src="productStoreLogo"
          style="width: 45px; height: auto; opacity: 0.20;"
        >
        <img
          v-else
          :src="LogoDarkPng"
          style="width: 45px; height: auto; opacity: 0.20;"
        >
      </div>

      <v-avatar
        v-if="storeLogo && product.Store && product.Store.Logo"
        :size="storeLogoStyle.Size"
        :style="`position: absolute; top: ${storeLogoStyle.Top}px; left: ${storeLogoStyle.Left}px;`"
      >
        <v-img :src="product.Store.Logo" />
      </v-avatar>
    </div>

    <v-list-item-content class="align-content-space-between py-3">
      <div class="align-center">
        <v-list-item-title>
          {{ productName }}
        </v-list-item-title>

        <v-list-item-subtitle class="brand-grey--text brand-text-small mt-1">
          {{ cartProductSelectedOptions }}
        </v-list-item-subtitle>
      </div>

      <div class="d-flex align-center">
        <product-price
          :product="product"
          auto-calculate
          cart
          class="brand-text-small"
        />

        <v-spacer />

        <product-tags
          v-if="showProductTags"
          :tags="product.Tags"
          icon-only
          small
          style="position:absolute; bottom: 13px; right: 16px;"
        />
      </div>
    </v-list-item-content>

    <v-list-item-action>
      <product-quantity
        :product="product"
        class="mr-1"
        hide-multiply-symbol
        outlined
      />
    </v-list-item-action>
  </v-list-item>
</template>

<script>

import CheckoutProductListItemMixin from '@/theme/default/components/checkout/CheckoutProductListItem.js'

export default {
  name    : 'CheckoutProductListItem',
  mixins  : [CheckoutProductListItemMixin],
  computed: {
    imageWidth() {
      return this.$vuetify.breakpoint.smAndUp ? 140 : 80
    },

    imageHeight() {
      return this.$vuetify.breakpoint.smAndUp ? 120 : 60
    }
  }
}
</script>

<style scoped src="@/theme/default/components/checkout/CheckoutProductListItem.css"></style>

<style scoped>
</style>

